<template>
  <v-btn
    color="info"
    outlined
    @click="login"
  >
    <v-icon left>
      {{ icons.mdiMicrosoft }}
    </v-icon>

    <span>{{ label }}</span>
  </v-btn>
</template>

<script>
import { mdiMicrosoft } from '@mdi/js'
import { useMicrosoftLogin } from '@/composables/useMicrosoftAuth'

export default {
  props: {
    label: {
      type: String,
      default: 'Logar com a Microsoft',
    },
  },

  setup() {
    const { loginComMicrosoft } = useMicrosoftLogin()

    return {
      login: loginComMicrosoft,
      icons: {
        mdiMicrosoft,
      },
    }
  },
}
</script>
